// Aturan jeda kiriman pengingat/penagihan ke pelanggan.
//
// Kenapa ada: menagih orang yang sama dua kali sehari membuat pelanggan tersinggung dan CS
// yang kena marah. Daftar kerja karena itu menandai siapa yang BARU SAJA dihubungi, bukan
// sekadar siapa yang berhutang.
const HARI = 86400_000;

/** Boleh dihubungi lagi? `minHari` 0 = pembatas dimatikan. `terakhirMs` null = belum pernah. */
export function bolehKirimLagi(terakhirMs: number | null, minHari: number, kiniMs: number): boolean {
  if (minHari <= 0) return true;
  if (terakhirMs == null || !Number.isFinite(terakhirMs)) return true;
  return kiniMs - terakhirMs >= minHari * HARI;
}

/** Sisa hari sebelum boleh dihubungi lagi (0 = boleh sekarang). Untuk ditampilkan ke CS. */
export function sisaJedaHari(terakhirMs: number | null, minHari: number, kiniMs: number): number {
  if (bolehKirimLagi(terakhirMs, minHari, kiniMs)) return 0;
  return Math.max(0, Math.ceil((minHari * HARI - (kiniMs - (terakhirMs as number))) / HARI));
}
